export default __webpack_public_path__ + "05_DistributeReport.bff7fa1b.png";